// extracted by mini-css-extract-plugin
export default {"logoStyle":"Logo_logoStyle__mpPpz","image":"Logo_image__bt1Kk"};